import { useTranslation } from 'react-i18next'
import { Head } from '#/components/head'
import { Text } from '#/components/ui/typography'


export default function OrganizationsLoading() {
  const { t } = useTranslation([ 'settings' ])

  return (
    <div className="w-full">

      <Head title={t('organization_list.page_title')} />

      <Text>{t('organization_list.loading')}</Text>

    </div>
  )
}
